import React, { useMemo, useState, useCallback } from 'react';
import ReactFlow, { Background, Controls } from 'reactflow';
import 'reactflow/dist/style.css';

import MetroStationNode from './MetroStationNode';
import { generateMapData } from './dataGenerator';
import JobDrawer from './JobDrawer';

const { nodes: initialNodes, edges: initialEdges } = generateMapData();

export default function App() {
  const [selectedNode, setSelectedNode] = useState(null);

  const nodeTypes = useMemo(() => ({ metroStation: MetroStationNode }), []);

  const onNodeClick = useCallback((event, node) => {
    if (node.type === 'groupLabel') return;

    event.preventDefault();
    setSelectedNode(node);
  }, []);

  const closeDrawer = () => setSelectedNode(null);

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#f9f9f9', fontFamily: 'sans-serif' }}>

      <ReactFlow
        defaultNodes={initialNodes}
        defaultEdges={initialEdges}
        nodeTypes={nodeTypes}

        onNodeClick={onNodeClick}
        onPaneClick={closeDrawer}

        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={true}

        minZoom={0.1}
        maxZoom={2}
        fitView
      >
        <Background color="#ccc" gap={50} size={1} />
        <Controls showInteractive={false} />

        <div style={{
          position: 'absolute', bottom: 30, left: 30,
          background: 'white', padding: '20px', borderRadius: '12px',
          boxShadow: '0 5px 20px rgba(0,0,0,0.1)', zIndex: 100
        }}>
          <h4 style={{ margin: '0 0 10px 0' }}>🗺️ Career Map</h4>
          <div style={{ display: 'flex', gap: '15px', fontSize: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span style={{ width: 12, height: 12, borderRadius: '50%', background: '#8E44AD' }}></span> Engineering
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span style={{ width: 12, height: 12, borderRadius: '50%', background: '#D35400' }}></span> Data
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span style={{ width: 12, height: 12, borderRadius: '50%', background: '#27AE60' }}></span> Product
            </div>
          </div>
          <p style={{ margin: '10px 0 0 0', color: '#666', fontSize: '11px' }}>
            Cliquez sur une station pour voir les détails.<br />
            Les pointillés représentent les passerelles.
          </p>
        </div>

      </ReactFlow>

      <JobDrawer node={selectedNode} onClose={closeDrawer} />

    </div>
  );
}